import { DataGrid } from "devextreme-react";
import { IStateStoringProps, StateStoring } from "devextreme-react/data-grid";
import { Editing } from "devextreme/ui/data_grid";
import * as React from "react";
import { ReactNode, RefObject, useMemo } from "react";
import useDataSource from "./hooks/DataSource";

interface IProps<TRow, TKey> {
    dgRef?:  RefObject<DataGrid<TRow, TKey>> | undefined;
    apiUrl: string;
    children?: ReactNode | undefined;
    allowAdd?: boolean;
    allowUpdate?: boolean;
    allowDelete?: boolean;
    onSaaved?: () => void;
    stateStoring?: IStateStoringProps
}

const GenericDataGrid = <TRow, TKey>({ dgRef, apiUrl, children, allowAdd, allowDelete, allowUpdate, onSaaved, stateStoring }: IProps<TRow, TKey>) => {

    const dgSource = useDataSource(apiUrl);    

    const gridEditSettings = useMemo((): Editing<TRow, TKey> => ({
        allowAdding: allowAdd,
        allowDeleting: allowDelete,
        allowUpdating: allowUpdate,
        useIcons: true,
        mode: "batch"
    }), [allowAdd, allowDelete, allowUpdate])

    return <DataGrid<TRow, TKey>
        ref={dgRef}
        dataSource={dgSource}
        editing={gridEditSettings}
        onSaved={onSaaved}        
        stateStoring={stateStoring}
        hoverStateEnabled
    >
        {children}
    </DataGrid>
}

export default GenericDataGrid;